/**
 * Zonas de delivery con costo propio, escritas por el negocio una por línea: «Los Palos Grandes: 5».
 * Si la dirección del cliente no coincide con ninguna zona ni con las zonas de cobertura, el asistente
 * consulta al equipo en lugar de inventar un costo.
 */

export interface DeliveryZoneFee {
  name: string
  fee: number
}

const LINE_PATTERN = /^(.+?)\s*[:=]\s*\$?\s*(\d+(?:[.,]\d{1,2})?)\s*(?:usd|\$)?$/i

export const DELIVERY_ZONES_ERROR = 'Escribe una zona por línea con su costo, por ejemplo: Los Palos Grandes: 5'

function meaningfulLines(raw: string): string[] {
  return raw
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
}

export function isValidDeliveryZonesInput(raw: string): boolean {
  return meaningfulLines(raw).every((line) => LINE_PATTERN.test(line))
}

/** Líneas inválidas se ignoran: solo se llama con entradas ya validadas. Una zona repetida conserva la última. */
export function parseDeliveryZones(raw: string): DeliveryZoneFee[] {
  const byName = new Map<string, DeliveryZoneFee>()
  for (const line of meaningfulLines(raw)) {
    const match = LINE_PATTERN.exec(line)
    if (!match) continue
    const name = match[1]!.trim()
    byName.set(name.toLowerCase(), { name, fee: Number(match[2]!.replace(',', '.')) })
  }
  return Array.from(byName.values())
}

export function formatDeliveryZones(zones?: ReadonlyArray<DeliveryZoneFee> | null): string {
  return (zones ?? []).map((zone) => `${zone.name}: ${zone.fee}`).join('\n')
}

const TIMEOUT_MIN = 5
const TIMEOUT_MAX = 1440

export const STAFF_CONSULT_TIMEOUT_ERROR = `Escribe un número de minutos entre ${TIMEOUT_MIN} y ${TIMEOUT_MAX}.`

/** Vacío = usar el plazo por defecto del sistema. */
export function isValidStaffConsultTimeoutInput(raw: string): boolean {
  const value = raw.trim()
  if (value === '') return true
  if (!/^\d+$/.test(value)) return false
  const minutes = Number(value)
  return minutes >= TIMEOUT_MIN && minutes <= TIMEOUT_MAX
}

export function parseStaffConsultTimeout(raw: string): number | null {
  const value = raw.trim()
  return /^\d+$/.test(value) ? Number(value) : null
}
